import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import { Location } from '@angular/common';
import {TicketsService} from '../../../services/tickets.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Ticket} from '../../../model/Ticket';
import {FaqCategory} from '../../../model/FaqCategory';
import {FaqCategoryService} from '../../../services/faq-category.service';
import {Label} from '../../../model/Label';
import {SendedFile} from '../../../model/SenderFile';
import {ToastrService} from "ngx-toastr";
import {NgbCollapse, NgbModal, NgbPopover} from "@ng-bootstrap/ng-bootstrap";
import {RouterExtService} from "../../../services/router-ext.service";
import {BreadcrumbComponent} from "../../../components/common/breadcrumb/breadcrumb.component";
import {BadgeComponent} from "../../../components/common/badge/badge.component";
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {StateDisplayPipe} from "../../../components/common/StateDisplayPipe";
import {VersionStripPipe} from "../../../components/common/VersionStripPipe";
import {VersionIntegrationStripPipe} from "../../../components/common/VersionIntegrationStripPipe";
import {TicketArticleComponent} from "../../../components/user/ticket-article/ticket-article.component";
import {AngularEditorComponent} from "../../../components/editor/angular-editor/angular-editor.component";
import {FormsModule} from "@angular/forms";
import {UploadFileComponent} from "../../../components/common/upload-file/upload-file.component";
import {MobileResponseComponent} from "../../../components/common/mobile-response/mobile-response.component";
import {CancelButtonComponent} from "../../../components/common/cancel-button/cancel-button.component";
import { SpinnerComponent } from 'src/app/components/common/spinner/spinner.component';

@Component({
    selector: 'app-ticket-detail',
    imports: [
    BreadcrumbComponent,
    BadgeComponent,
    FaIconComponent,
    NgbPopover,
    StateDisplayPipe,
    VersionStripPipe,
    VersionIntegrationStripPipe,
    TicketArticleComponent,
    NgbCollapse,
    AngularEditorComponent,
    FormsModule,
    UploadFileComponent,
    MobileResponseComponent,
    CancelButtonComponent,
    SpinnerComponent
],
    templateUrl: './ticket-detail.component.html',
    styleUrls: ['./ticket-detail.component.css']
})
export class TicketDetailComponent implements OnInit {

  @ViewChild('confirmclose') confirmclose: TemplateRef<any>;
  @ViewChild('confirmrevive') confirrevive: TemplateRef<any>;

  ticket: Ticket;
  categories: FaqCategory[];
  hideArticle: boolean[];
  hideResponse = true;
  showAllButton = true;
  hideMobileResponse = true;
  updating = false;
  error = false;

  response: {
    body: string,
    cc: string,
    subject: string,
    stateId: string,
    filesIds: any[]
  };
  sendedFiles: SendedFile[];

  states: Map<string, string>;
  closedLabel: Label;

  constructor(private ticketService: TicketsService,
              private route: ActivatedRoute,
              private router: Router,
              private location: Location,
              private routerExtService: RouterExtService,
              private faqCategoryService: FaqCategoryService,
              private toastr: ToastrService,
              private modalService: NgbModal) {
  }

  ngOnInit(): void {
    this.closedLabel = new Label();
    this.closedLabel.name = 'Clos';
    this.closedLabel.backcolor = '#444';
    this.closedLabel.textcolor = '#ddd';

    this.faqCategoryService.getAllCategories().subscribe(cats => {
      this.categories = cats;
    });
    this.ticketService.getStates().subscribe(states => {
      this.states = states;
    });
    this.initGetTicket();
  }

  goBack(): void {
    if (this.routerExtService.getPreviousUrl()) {
      this.location.back();
    } else {
      this.router.navigate(['/tickets']);
    }
  }

  initGetTicket(): void {
    this.response = {
      body: '',
      cc: '',
      subject: '',
      stateId: '',
      filesIds: []
    };
    this.sendedFiles = [];
    const id = this.route.snapshot.paramMap.get('id');
    this.getTicketById(id);
  }

  closeTicket(): void {
    this.modalService.open(this.confirmclose).result.then(() => {
      this.updateTicket(true, false);
    });
  }

  reviveTicket(): void {
    this.modalService.open(this.confirrevive).result.then(() => {
      this.updateTicket(false, true);
    });
  }

  getTicketById(id: string): void {
    this.ticketService.getFullTicket(id).subscribe(data => {
      this.ticket = data;
      this.response.subject = this.ticket.title;
      this.response.cc = this.ticket.articles[this.ticket.articles.length - 1].cc.join(',');
      this.hideArticle = this.ticket.articles.map(t => true);
      this.hideArticle[this.hideArticle.length - 1] = false;
    }, () => {
      // Ticket not found, fallback to ticket number
      this.ticketService.getTicketNumber(id).subscribe(data => {
        this.router.navigate(['/tickets/' + data.number]);
        this.getTicketById(data.number);
      }, () => {
        this.error = true;
        this.ticket = new Ticket();
      });
    });
  }

  updateTicket(close?: boolean, revive?: boolean): void {
    this.doUpdate(!!close, !!revive, this.sendedFiles.map(sf => sf.id));
  }

  doUpdate(close: boolean, revive: boolean, filesIds: any[]): void {
    this.response.filesIds = filesIds;
    let startToFind: string;
    if (revive) {
      startToFind = close ? '4' : '1 - RELANCE';
    } else {
      startToFind = close ? '4' : '1 - RETOUR';
    }
    for (const [key, value] of Object.entries(this.states)) {
      if (value.startsWith(startToFind)) {
        this.response.stateId = key;
        break;
      }
    }
    const id = this.ticket.id;
    this.ticket = undefined;
    this.updating = true;
    this.ticketService.updateTicket(id, this.response).subscribe(() => {
      this.initGetTicket();
    });
    this.hideResponse = true;
    this.hideMobileResponse = true;
  }

  getCategoryFromSlug(slug: string): FaqCategory {
    return slug ? this.categories.find(c => {
      return c.slug.toLowerCase() === slug.toLowerCase();
    }) : null;
  }

  sendedFilesNotFinished(): boolean {
    return this.sendedFiles.some(s => !s.uploaded);
  }

  scrollBottom(): void {
    setTimeout(() => {
      document.body.scrollIntoView(false);
    });
  }

  detectBadImage(event): void {
    const data = event.clipboardData.getData('text/html');
    if (data.indexOf('src="file') !== -1) {
      this.toastr.error('Attention, impossible de coller du texte et une image simultanément. Merci d’ajouter votre image en pièce jointe du ticket.');
      event.preventDefault();
    }
  }

  setReduced(index: number): void {
    const newValue = !this.hideArticle[index];
    this.hideArticle[index] = newValue;
    if (this.hideArticle.indexOf(!newValue) === -1) {
      this.showAllButton = newValue;
    }
  }

  showAll(): void {
    this.hideArticle = this.hideArticle.fill(false);
    this.showAllButton = false;
  }

  hideAll(): void {
    this.hideArticle = this.hideArticle.fill(true);
    this.showAllButton = true;
  }

}
